import { Aspect } from "../tree/aspect";
import { PrototypeModel } from "./prototype-model";
import { ContentModel } from "./content-model";
import { Genus } from "../tree/genus";

export class ViewAttributes {
    readonly prototypeModel: PrototypeModel = new PrototypeModel();

    constructor(
        private readonly custome: any,
        private readonly aspects: Map<string, Aspect>
    ) {}

    load(attributes?: string[]): void {
        const selected: Aspect[] = [];

        if (attributes?.length) {
            selected.push(
                ...attributes
                    .map(id => this.aspects.get(id))
                    .filter((x): x is Aspect => !!x)
            );
        }

        this.prototypeModel.load(...selected);
    }

    reload(attributes: Aspect[]): void {
        this.prototypeModel.clear();
        this.prototypeModel.load(...attributes);
    }

    contentModel(genus: Genus): ContentModel {
        return new ContentModel(
            this.prototypeModel,
            genus,
            this.custome,
        );
    }
}
